var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLesson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#466dec;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1899",
    "data-name": "Group 1899"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_924",
    "data-name": "Path 924"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.35,97.6a3,3,0,0,1-3-3V15.42a12.91,12.91,0,0,1,12.9-12.9H74.58A10.43,10.43,0,0,1,85,12.94a3,3,0,0,1-6,0,4.42,4.42,0,0,0-4.42-4.42H27.25a6.91,6.91,0,0,0-6.9,6.9V89.55L48.24,74.32a3,3,0,1,1,2.87,5.27L18.78,97.24A3,3,0,0,1,17.35,97.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_925",
    "data-name": "Path 925"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82,97.6a3,3,0,0,1-1.44-.37L48.24,79.59a3,3,0,1,1,2.87-5.27L79,89.55V12.94a3,3,0,1,1,6,0V94.6a3,3,0,0,1-3,3Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Polygon_32",
    "data-name": "Polygon 32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42,29.6,34.44,42.77,42,55.93H57.12l7.57-13.16L57.12,29.6H42m-3.47-6H60.59l11,19.17-11,19.16H38.54l-11-19.16Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/Lesson.637dcc7b2e1f00bea0fc326b5610d78b.svg";
export { ForwardRef as ReactComponent };